import React, { useState } from "react";
import {
  Button,
  Drawer,
  Dropdown,
  Message,
  Modal,
  toaster,
} from "rsuite";
import { updateStripeInvoice } from "../services/DashboardService";

const StripeInvoiceUpdateModal = ({
  id,
  type,
  updateTrigger,
  setUpdateTrigger,
  data,
}) => {
  const [openUpdateModal, setOpenUpdateModal] = React.useState(false);
  const [status, setStatus] = useState(
    data.invoiceStatus || ""
  );
  const [reason, setReason] = useState(data.reason);

  const handleUpdate = async () => {
    if (status.length === 0) {
      toaster.push(
        <Message showIcon type="error" header="Error">
          Select a Valid Status
        </Message>,
        {
          placement: "topEnd",
          duration: 2000,
        }
      );
    } else {
      await updateStripeInvoice(
        data.invoiceNumber,
        status
      )
        .then((res) => {
          if (res.status === 200) {
            toaster.push(
              <Message showIcon type="success" header="success">
                Updated successfully!
              </Message>,
              {
                placement: "topEnd",
                duration: 2000,
              }
            );
            setUpdateTrigger(!updateTrigger);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <Button appearance="link" onClick={() => setOpenUpdateModal(true)}>
        UPDATE
      </Button>
      <Drawer
        open={openUpdateModal}
        onClose={() => {
          setOpenUpdateModal(false);
          setReason("");
        }}
      >
        <Drawer.Header>
          <Modal.Title>UPDATE</Modal.Title>
        </Drawer.Header>
        <Drawer.Body>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <p>Invoice Number: {data.invoiceNumber}</p>
            <p>Invoice Data: {data.invoiceDate}</p>
            <p>Invoice Status: {data.invoiceStatus}</p>
            <p>Stripe Invoice Status: {data.stripeInvoiceStatus}</p>

            <p>Select Status</p>

            <Dropdown
              className="dropdown-width mb-4 "
              title={status.length > 0 ? status : "Select"}
              onSelect={(e) => {
                setStatus(e);
              }}
            >
              <>
                <Dropdown.Item eventKey={""}>Select</Dropdown.Item>
{/*                 <Dropdown.Item eventKey={"INIT"}>INIT</Dropdown.Item> */}
{/*                 <Dropdown.Item eventKey={"SUCCESS"}>SUCCESS</Dropdown.Item> */}
{/*                 <Dropdown.Item eventKey={"REFUNDED"}>REFUNDED</Dropdown.Item> */}
{/*                 <Dropdown.Item eventKey={"CREATED"}>CREATED</Dropdown.Item> */}
{/*                 <Dropdown.Item eventKey={"WEBHOOK_PENDING"}>WEBHOOK_PENDING</Dropdown.Item> */}
                <Dropdown.Item eventKey={"FAILED"}>FAILED</Dropdown.Item>
                <Dropdown.Item eventKey={"PENDING"}>PENDING</Dropdown.Item>
              </>
            </Dropdown>

            <Button
              className="mt-3"
              onClick={handleUpdate}
              appearance="primary"
            >
              UPDATE
            </Button>
          </div>
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default StripeInvoiceUpdateModal;